<!-- DefaultLayout.vue -->
<template>
  <div>
    <!-- Your default layout markup, e.g., a navbar -->
    <router-view></router-view>
    <!-- Nested routes will be rendered here -->
  </div>
</template>
